export const PointType = {
  HOME: "HOME",
  WORK: "WORK",
  SAVED_PLACE: "SAVED_PLACE",
  RECENT: "RECENT",
  AS_DIRECTED: "AS_DIRECTED",
  SEARCH: "SEARCH",
  POPULAR: "POPULAR",
};

